define('modules/editor/views/elements/form',['require','exports','module','./element','../../models/editorstate','common/models/appstate','underscore','common/views/alert_view','env','lib/util','ldsh!../../templates/elements/form_amp','ldsh!../../templates/elements/form'],function (require, exports, module) {
  'use strict';

  var BaseElement = require('./element'),
    EditorState = require('../../models/editorstate'),
    AppState = require('common/models/appstate'),
    _ = require('underscore'),
    AlertView = require('common/views/alert_view'),
    config = require('env'),
    util = require('lib/util');

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  module.exports = BaseElement.extend({
    className: 'ed-panel-item ed-item-form',
    template: null,

    initialize: function (options) {
      this.template = this._getFormTemplate();
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.call(this, options);
      this.listenTo(this.model._propertyVent, 'change', function () {
        this.render();
      });
      this.listenTo(EditorState, 'change:variant', this._bindEditorStateVariant);
      this.listenTo(this.model, 'integration:disabled', this.showAlert);
      var login = this.model.hasFacebookLogin();
      if (login) EditorState.setFBAppId(login.appId);
    },

    myEvents: {
      'submit form': 'preventDefault',
      'click .checkbox-terms > a': 'preventDefault',
      'focus input, focus textarea, focus select, click input, click select': 'blur',
    },

    onDrop: function () {
      console.log('Drop at form!');
    },

    updateConfirmationUrl: function () {
      this.render();
    },

    helpers: function () {
      var variantModel = EditorState.getVariant(),
        confirmationModel = variantModel.getPropertyGroup('page:confirmation'),
        conversionModel = variantModel.getPropertyGroup('page:conversion'),
        gtmModel = variantModel.getPropertyGroup('page:gtm'),
        formConversionModel = this.model.getPropertyGroup('form:conversion'),
        correoDirectModel = this.model.getPropertyGroup('form:integration:correodirect'),
        defaultsModel = variantModel.getPropertyGroup('page:defaults'),
        successMessage =
          conversionModel.get('conditionalExec') && conversionModel.get('successMessage'),
        safeSuccessMessage = successMessage && escapeHtml(successMessage),
        isMultistep = variantModel.content.length > 2,
        nextStep = +formConversionModel.get('step') + 1,
        customAMPScriptModel = this.model.getPropertyGroup('form:customAMPScript');

      return {
        language: defaultsModel.get('language'),
        variantId: variantModel.id,
        gtm: gtmModel.get('gtmId'),
        externalConfirmationUrl: confirmationModel.get('confirmationUrl'),
        confirmationSendParams: confirmationModel.get('sendParams'),
        isMultistep: isMultistep,
        isSingleStep: !isMultistep,
        skipConversion: !isMultistep && conversionModel.get('skip'),
        reqConversion:
          !isMultistep &&
          conversionModel.get('conditionalExec') &&
          conversionModel.get('reqConversion'),
        executionStep: formConversionModel.get('executeConversion'),
        confirmationUrl:
          variantModel.content.length - 1 == nextStep ? '{{confirmation_url}}' : '{{step_url}}',
        successMessage: successMessage,
        escapedSuccessMessage: safeSuccessMessage,
        isCorreoDirectAvailable: AppState.isCorreoDirectAvailable(),
        isCorreoDirectActive: correoDirectModel.get('active'),
        idaf: correoDirectModel.get('idaf'),
        integrationData: this.model.getIntegrationData(),
        compatData: this.model.getCompatData(),
        countryId: AppState.getCountryId(),
        googleRecaptchaData: this.model.getGoogleRecaptchaData(),
        verifyUrl: this.getVerifyUrl(),
        customAMPScript: util.getCustomAMPScript(customAMPScriptModel),

        //'show-all-on-submit' 'as-you-go' 'show-first-on-submit' 'interact-and-submit'
        formValidationReporting: 'interact-and-submit',
      };
    },

    getVerifyUrl: function () {
      return config.validationServerHostSuffix;
    },

    blur: function (e) {
      $(e.target).blur();
    },

    preventDefault: function (e) {
      e.preventDefault();
      e.stopPropagation();
    },

    onEditContent: function () {
      this.model.editFormFields();
    },

    _bindEditorStateVariant: function () {
      _.once(function (variant) {
        this.listenTo(variant, 'change:page:confirmation', this.updateConfirmationUrl);
      });
    },

    render: function () {
      module.exports.__super__.render.apply(this);
      var rect = { height: this.$el.outerHeight() };
      this.model.triggerMethod('redraw', rect);
      return this;
    },

    onRender: function () {
      var geometry = this.model.getPropertyGroup('form:geometry');
      if (geometry.get('position') === 'fixed' && EditorState.isGenerateMode()) {
        var top = geometry.get('top'),
          left = geometry.get('left');
        this.$el.css({
          position: 'fixed',
          'margin-top': top + 'px',
          'margin-left': left + 'px',
          top: 'auto',
          left: 'auto',
        });
      }
      this.$el.i18n();
    },

    showAlert: function () {
      AlertView.showAlert({
        message: $.i18n.t('editor.integrationDisabled'),
        alertType: 'danger',
      });
    },

    _getFormTemplate: function () {
      if (EditorState.getAMPState()) {
        return require('ldsh!../../templates/elements/form_amp');
      }

      return require('ldsh!../../templates/elements/form');
    },
  });
});

